export const REVIEWS_SLIDER_SETTINGS = {
  infinite: false,
  slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
};
